export default "__VITE_ASSET__B_fEZ$9N__"